import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SUBSCRIPTION_STATUS: "Status for abonnement",
      STATUS: "inaktiv",
      YOUR_DELIVERIES_ARE_STOPPED: "Leveringene dine er satt på pause",
      RESUME_DELIVERIES_AND_ENJOY_HEALTHY_RECIPES:
        "Start leveringene og nyt gode og sunne oppskrifter",
      RESUME: "Gjenoppta leveranser",
    },
    dk: {
      SUBSCRIPTION_STATUS: "Status på abonnement",
      STATUS: "annulleret",
      YOUR_DELIVERIES_ARE_STOPPED: "Dine leveringer er stoppet",
      RESUME_DELIVERIES_AND_ENJOY_HEALTHY_RECIPES:
        "Genaktivér dine leveringer, og nyd gode og sunde opskrifter.",
      RESUME: "Genaktivér",
    },

    se: {
      SUBSCRIPTION_STATUS: "Prenumerationsstatus",
      STATUS: "avslutad",
      YOUR_DELIVERIES_ARE_STOPPED: "Din prenumeration är avslutad",
      RESUME_DELIVERIES_AND_ENJOY_HEALTHY_RECIPES:
        "Starta dina leveranser och njut av goda och sunda recept.",
      RESUME: "Återuppta leveranser",
    },
  } as const
)[language];
